import { VisitCustomer, Visit } from './customer';

// Enum for Status
export enum Status {
  NotStarted = 'draft',
  InProgress = 'in progress',
  Complete = 'complete',
  Skipped = 'skipped'
}

export interface Page {
  page: string; // Page name e.g. "Abrasive", "Paint"
  answers: Answer[]; // Answers specific to this page
  comment?: string; // Optional comment for the page
  attachments?: Attachment[]; // Optional page-level attachments
}

// Attachment Type
export interface Attachment {
  name: string; // Unique identifier of the file stored
  mimeType: string; // MIME-type of the file
  createdAt?: string;
  audioLength?: number;
}

// Answer Type
export interface Answer {
  questionId: string; // Unique identifier of the question being answered
  value: string | number | null | string[]; // Answer to the question, in appropriate type
  productReference?: string | null; // Product reference, if applicable
  language?: string; // Language in which the answer was given
  attachments?: Attachment[]; // Optional binary attachments to this question
}

// Status History Item
export interface StatusHistoryItem {
  status: Status; // Status that was set
  changedAt: string; // ISO 8601 datetime when the status was set
}

export interface Subsection {
  subsectionId: string;
  answers: Answer[]; // For subsection-wide (non-page) questions
  pages?: Page[]; // For product-specific pages
  status: Status;
  statusHistory: StatusHistoryItem[];
  comment?: string;
  attachments?: Attachment[];
}

// Section Type
export interface Section {
  sectionId: string; // Unique identifier of the section being answered
  subsections: Subsection[]; // List of subsections for this section
}

// Survey Response Type
export interface SurveyResponse {
  id: string;
  responseId: string; // Unique identifier for the survey response
  surveyDefinitionId: string; // Unique identifier for the survey definition
  surveyVersion: string; // Version of the survey definition
  status: Status; // Current status of this response
  statusHistory: StatusHistoryItem[]; // History of survey statuses change, oldest to newest
  customerId?: string; // Unique identifier for the customer
  customerName?: string; // Name of the customer
  customer?: VisitCustomer; // Survey response customer
  visit?: Visit; // Survey customer visit information
  representativeId: string; // Unique identifier for representative
  createdAt: string; // ISO 8601 datetime when the response was first created
  sections: Section[]; // Sections with their answers and status
  comment?: string;
  _ts?: number;
  _deleted: boolean;
}
